import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme, { colors: any }>((theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: (props) => props.colors.colorBackground,
    alignItems: 'center',
    padding: '0px 5px',
  },
  textTitle: {
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(18),
    color: '#ffffff',
    marginBottom: 8,
    textDecoration: 'none',
    display: 'block',
  },
  textLink: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(22),
    letterSpacing: '0.1px',
    color: (props) => props.colors.textBody,
    margin: '0px 20px',
    textDecoration: 'none',
    transition: 'color 0.3s ease',
    '&:hover': {
      color: '#00508C',
      textDecoration: 'underline',
      '& $arrowIcon': {
        color: '#00508C',
      },
    },
  },
  arrowIcon: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(22),
    color: (props) => props.colors.textBody,
    verticalAlign: 'middle',
    transition: 'color 0.3s ease',
  },
  textTitleSelected: {
    cursor: 'pointer',
    padding: '15px 40px',
    color: (props) => props.colors.colorBackgroundSecundary,
    backgroundColor: (props) => props.colors.accentColor,
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  card: {
    WebkitJustifyContent: 'flex-end',
    WebkitAlignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    flexDirection: 'column',
    alignItems: 'end',
    borderRadius: '15px 15px 0px 0px',
    marginBottom: 20,
    minWidth: 320,
    width: '30%',
    height: 219,
    color: (props) => props.colors.textAccentColor,
    background: (props) => props.colors.colorGradient,
    position: 'relative',
    border: '1px solid #000000ff',
  },
  boxServicesSelected: {
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      justifyContent: 'center',
    },
  },
  servicesSelected: {
    display: 'flex',
    justifyContent: 'space-between',
    maxWidth: 'fit-content',
    flexWrap: 'wrap',
    alignItems: 'center',
    margin: '40px 0px 40px 0px',
    [theme.breakpoints.down('xs')]: {
      margin: '40px 0px',
      maxWidth: '300px',
      justifyContent: 'space-around',
      border: '1px solid #e3e3e3',
    },
  },
  textCard: {
    fontWeight: 500,
    textAlign: 'start',
    display: '-webkit-box',
    WebkitLineClamp: 4,
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    fontSize: theme.typography.pxToRem(16),
    marginBottom: 20,
  },
  textCategoryName: {
    fontSize: 14,
    textTransform: 'uppercase',
    margin: '0 6px',
    fontWeight: 500,
  },
  textTitleInitial: {
    position: 'relative',
    textTransform: 'uppercase',
    fontFamily: 'Roboto',
    padding: '10px 0px 0px 3px',
    marginBottom: 5,
    fontWeight: 'bold',
    color: (props) => props.colors.textBody,
    left: 8,
    fontSize: theme.typography.pxToRem(36),
    '&::after': {
      content: '""',
      display: 'block',
      width: 4,
      height: 30,
      backgroundColor: (props) => props.colors.accentColor,
      position: 'absolute',
      bottom: 11,
      marginLeft: -14,
      left: 5,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(28),
      textAlign: 'center',
      marginBottom: 50,
      '&::after': {
        bottom: 4,
      },
    },
  },
  borders: {
    border: `1px solid ${(props) => props.colors.accentColor}`,
    [theme.breakpoints.down('xs')]: {
      border: 'none',
    },
  },
  cardSecondary: {
    width: '100%',
    borderRadius: '15px 15px 0px 0px',
    backgroundColor: (props) => props.colors.colorBackground,
    height: 178,
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: 20,
    paddingTop: 27,
    alignItems: 'flex-start',
  },
  iconService: {
    margin: '-7px 30px -20px 0px',
  },
  box: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '20px',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      // textAlign: 'center',
    },
  },
}))
